/**
 * Mensagens rotativas enquanto a orquestração IA roda (estilo “spinner” tipo terminal/Claude Code).
 * Português, tom leve mas adequado ao CRM.
 */
export const ORCHESTRATION_SPINNER_MESSAGES: string[] = [
  'Lendo a conversa…',
  'Conectando o contexto…',
  'Consultando diretrizes…',
  'Buscando na base…',
  'Cogitando a melhor linha…',
  'Amarrando as pontas…',
  'Ajustando o tom…',
  'Estruturando a resposta…',
  'Refinando o texto…',
  'Conferindo detalhes…',
  'Sintetizando ideias…',
  'Quase lá…',
  'Devaneando com propósito…',
  'Borbulhando ideias…',
  'Orquestrando o próximo passo…',
  'Pesquisando nuances…',
  'Costurando a mensagem…',
  'Polindo a redação…',
  'Canalizando boas vibes…',
  'Calculando o melhor ângulo…',
  'Misturando empatia e clareza…',
  'Destilando a resposta…',
  'Acertando o compasso…',
  'Afinando as palavras…',
];
